import { useEffect, useState } from 'react';
import { getMachinesOverview } from '../api/api';

const POLL_INTERVAL_MS = 30000;

// Module-level store so every component using this hook shares a single
// 30-second polling loop (one request per cycle) instead of each component
// starting its own fetches.
let cachedOverview = null;
const subscribers = new Set();
let pollTimer = null;

async function fetchOverview() {
  try {
    const response = await getMachinesOverview();
    cachedOverview = response.data;
    subscribers.forEach(callback => callback(cachedOverview));
  } catch (error) {
    console.error('Error fetching machines overview:', error);
  }
}

function subscribe(callback) {
  subscribers.add(callback);
  // Late subscribers get whatever is already cached right away.
  if (cachedOverview !== null) {
    callback(cachedOverview);
  }
  if (subscribers.size === 1) {
    fetchOverview();
    pollTimer = setInterval(fetchOverview, POLL_INTERVAL_MS);
  }
  return () => {
    subscribers.delete(callback);
    if (subscribers.size === 0 && pollTimer) {
      clearInterval(pollTimer);
      pollTimer = null;
    }
  };
}

// Returns the overview payload ({ machines: [...], generated_at }) or null
// before the first successful load.
export default function useMachinesOverview() {
  const [overview, setOverview] = useState(cachedOverview);
  useEffect(() => subscribe(setOverview), []);
  return overview;
}
